/**
 * AdminQuestRpcClient - AtomRpc integration for admin quest endpoints
 *
 * This uses AtomRpc.Tag to create a special context tag that provides
 * proper integration with the atom runtime.
 *
 * The ClerkTokenGetter layer reads the `__session` cookie directly (see
 * `readClerkSessionCookieToken`), falling back to `globalThis.__clerkSession`
 * when the cookie isn't present.
 *
 * @example
 * ```typescript
 * const questsAtom = AdminQuestRpcClient.runtime.atom((get) =>
 *   Effect.gen(function*() {
 *     const client = yield* AdminQuestRpcClient;
 *     const quests = yield* client("admin.quest.findMany", void 0);
 *     return quests;
 *   })
 * );
 * ```
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminQuestRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminQuestRpcClient extends AtomRpc.Tag<AdminQuestRpcClient>()(
  "AdminQuestRpcClient",
  {
    group: AdminQuestRpcs,
    protocol: makeRpcClientLayer(AdminQuestRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
